import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";

const TryItText = () => {
  const headingControls = useAnimation();
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.4,
  });

  useEffect(() => {
    if (inView) {
      headingControls.start({
        opacity: 1,
        y: 0,
        transition: { delay: 1.2, duration: 0.5 },
      });
    } else {
      headingControls.start({ opacity: 0, y: 20 });
    }
  }, [inView, headingControls]);

  return (
    <Box ref={ref}>
      <Box
        component={motion.div}
        animate={headingControls}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // gap: "20px",
          gap: { xs: "10px", sm: "15px", lg: "20px" },
          // p: { xs: "10px", sm: "20px" },
          cursor: "pointer",
          position: "relative",
          zIndex: 999,
        }}
        whileHover={{
          scale: 1.2,
          transition: { duration: 0.4 },
        }}
      >
        <Link to="/client/login">
          <Typography
            sx={{
              // fontSize: { xs: "20px", lg: "40px" },
              // letterSpacing: "8.8px",
              // lineHeight: "39px",
              fontSize: { xs: "18px", sm: "25px", lg: "40px" },
              letterSpacing: { xs: "5px", sm: "6px", lg: "8.8px" },
              lineHeight: { xs: "28px", sm: "32px", lg: "39px" },
              color: "#fff",
              fontWeight: 500,
              transition: "transform 0.3s ease",
            }}
          >
            TRY IT FOR FREE
          </Typography>
        </Link>
        <Box>
          <svg
            className="svg-arrow"
            xmlns="http://www.w3.org/2000/svg"
            width="123"
            height="24"
            viewBox="0 0 123 24"
            fill="none"
          >
            <path
              d="M2 10.5C1.17157 10.5 0.5 11.1716 0.5 12C0.5 12.8284 1.17157 13.5 2 13.5V10.5ZM122.061 13.0607C122.646 12.4749 122.646 11.5251 122.061 10.9393L112.515 1.3934C111.929 0.807611 110.979 0.807611 110.393 1.3934C109.808 1.97919 109.808 2.92893 110.393 3.51472L118.879 12L110.393 20.4853C109.808 21.0711 109.808 22.0208 110.393 22.6066C110.979 23.1924 111.929 23.1924 112.515 22.6066L122.061 13.0607ZM2 13.5H121V10.5H2V13.5Z"
              fill="white"
            />
          </svg>
        </Box>
      </Box>
    </Box>
  );
};

export default TryItText;
